// src/hooks/mutations/useDeleteRoute.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteRoute } from "../../api/routes";

export function useDeleteRoute() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: deleteRoute,

    // optimistic update for snappy UI
    onMutate: async (id) => {
      await qc.cancelQueries({ queryKey: ["routes"] });
      const previous = qc.getQueryData(["routes"]);
      qc.setQueryData(["routes"], (old = []) => {
        // old might be an array you returned from fetchRoutes()
        return Array.isArray(old) ? old.filter((r) => r.id !== id) : old;
      });
      return { previous };
    },
    onError: (_err, _id, ctx) => {
      if (ctx?.previous) qc.setQueryData(["routes"], ctx.previous);
    },
    onSettled: () => {
      // if other views depend on routes (e.g., heatmap), refresh them too
      qc.invalidateQueries({ queryKey: ["routes"] });
      qc.invalidateQueries({ queryKey: ["heatmap"] }); // if you use one
    },
  });
}

export default useDeleteRoute;
